import React from 'react';

import { Link, LinkProps } from "react-router-dom";
import './style.scss';

interface propsInterface {
  children: React.ReactNode;
  className?: string;
  align?: 'right' | 'left' | 'center';
  type?: 'type1';
}

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

const NavBarThree = ({ children, className, align, type }: propsInterface) => {
  let extraClassName = className || '';
  extraClassName += align ? ` o-${align}` : '';
  extraClassName += type ? ` o-${type}` : '';

  return (
    <div className={`v-navbar-three ${extraClassName}`}>
      {children}
    </div>
  );
}

NavBarThree.Button = (props: ButtonProps) => {
  return <button
    {...props}
    className={`o-item ${props.className ? props.className : ''}`}
  >{props.children}</button>;
}

NavBarThree.Link = (props: LinkProps) => {
  return <Link
    {...props}
    className={`o-item ${props.className ? props.className : ''}`}
  >{props.children}</Link>;
}

export default NavBarThree;
